import React, {useEffect, useState} from 'react';
import About from '../components/About.jsx'
import Intro from '../components/Intro.jsx'
import Experience from '../components/Experience.jsx';
import Portfolio from '../components/Portfolio.jsx'
import Blog from '../components/Blog.jsx'
import NavBar from '../components/NavBar.jsx'

function Home() {
  const [details, setDetails] = useState([]);

    return (
      <div style={{"height":"100%"}}>
        <NavBar/>
        <Intro/>
        <About/>
        <Experience/>
        <Portfolio/>
        {/* <Blog/> */}
      </div>
    )

}

export default Home
